import React, { useContext } from 'react';

import { media } from 'context';
import { Layout, Text } from 'ds';

import { ReactComponent as Step1 } from 'ux/Tenant/PantryAndSupplies/Onboarding/consumables_how_it_works_step_1.svg';
import { ReactComponent as Step2 } from 'ux/Tenant/PantryAndSupplies/Onboarding/consumables_how_it_works_step_2.svg';
import { ReactComponent as Step3 } from 'ux/Tenant/PantryAndSupplies/Onboarding/consumables_how_it_works_step_3.svg';

const ConsumablesHowItWorksSteps = () => {
  const { isMobile } = useContext(media);
  return (
    <Layout
      direction={isMobile ? 'column' : 'row'}
      borderBottom
      {...(isMobile ? { height: '100%', padding: 24, gap: 24 } : { height: 106, paddingY: 24, paddingX: 40, gap: 36 })}
    >
      <Layout direction="row" gap={16}>
        <Layout width={40} height={40} minWidth={40} minHeight={40}>
          <Step1 />
        </Layout>
        <Layout direction="column" gap={2}>
          <Text size="body-md" color="purple-gradient" semibold>
            Add your first items
          </Text>
          <Text size="body-xs">Pick your favorites and check out to start your twice-a month restocking service.</Text>
        </Layout>
      </Layout>
      <Layout direction="row" gap={16}>
        <Layout width={40} height={40} minWidth={40} minHeight={40}>
          <Step2 />
        </Layout>
        <Layout direction="column" gap={2}>
          <Text size="body-md" color="purple-gradient" semibold>
            Switch it up over time
          </Text>
          <Text size="body-xs">Tweak each order as much as you like up to 5 business days before delivery.</Text>
        </Layout>
      </Layout>
      <Layout direction="row" gap={16}>
        <Layout width={40} height={40} minWidth={40} minHeight={40}>
          <Step3 />
        </Layout>
        <Layout direction="column" gap={2}>
          <Text size="body-md" color="purple-gradient" semibold>
            We stock it. You relax.
          </Text>
          <Text size="body-xs">
            Track your order and see photos of your items unpacked and put away — ready to use, not just dropped off.
          </Text>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default ConsumablesHowItWorksSteps;
